import React from 'react';
import {format, isValid} from 'date-fns';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditOutlined from '@mui/icons-material/EditOutlined';
import CalendarTodayOutlined from '@mui/icons-material/CalendarTodayOutlined';
import ArrowForward from '@mui/icons-material/ArrowForward';
import HotelOutlined from '@mui/icons-material/HotelOutlined';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import KitesurfingOutlined from '@mui/icons-material/KitesurfingOutlined';

const dateLabel = (value) => {
  const date = value ? new Date(value) : null;
  return date && isValid(date) ? format(date, 'HH:mm do MMM') : '—';
};

export default function EventHeader({event, profileCount, onEdit}) {
  const metrics = [
    {label: 'From', value: dateLabel(event.startDate), icon: <CalendarTodayOutlined />},
    {label: 'To', value: dateLabel(event.endDate), icon: <ArrowForward />},
    {label: 'Kites', value: profileCount, icon: <KitesurfingOutlined sx={{color: '#1866b8'}} />},
    {label: 'Sleepers', value: event.sleepers, icon: <HotelOutlined />},
    {label: 'Day Guests', value: event.dayGuests, icon: <PersonOutlineOutlined />},
  ];

  return (
    <Box component="header" sx={{pt: 3, pb: 3, mb:1, borderBottom: '1px solid', borderColor: 'divider'}}>
      <Box sx={{display: 'flex', flexDirection: {xs: 'column', md: 'row'}, alignItems: {xs: 'stretch', md: 'flex-start'}, justifyContent: 'space-between', gap: 1.5}}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0}}>
        <Box component="h1" sx={{m: 0, fontSize: {xs: 22, sm: 26}, fontWeight: 700, lineHeight: 1.2, overflowWrap: 'anywhere'}}>
          {event.groupName}
        </Box>
        {onEdit && <IconButton aria-label="Edit event" onClick={onEdit} size="small"><EditOutlined /></IconButton>}
      </Box>

      {(event.type || event.company) && <Box sx={{display: 'flex', flexDirection: {xs: 'row', md: 'column'}, alignItems: {xs: 'center', md: 'flex-end'}, flexWrap: 'wrap', gap: '8px 20px', color: 'text.secondary', fontSize: 14, textAlign: {md: 'right'}, overflowWrap: 'anywhere', minWidth: 0, maxWidth: {md: '40%'}}}>
        {event.type && <Box component="span" sx={{fontWeight: 600, textTransform: 'uppercase'}}>{event.type}</Box>}
        {event.company && <span>{event.company}</span>}
      </Box>}
      </Box>

      <Box component="dl" sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: '1.4fr 1.4fr 1fr 1fr 1fr'}, gap: {xs: 2, lg: 0}, mt: 3, mb: 0}}>
        {metrics.map(({label, value, icon}) => (
          <Box key={label} sx={{display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, pl: {lg: 3}, borderLeft: {lg: '1px solid'}, borderColor: {lg: 'divider'}, '&:first-of-type': {pl: 0, borderLeft: 0}}}>
            <Box aria-hidden="true" sx={{display: 'flex', color: 'text.secondary', flexShrink: 0, '& svg': {width: 22, height: 22}}}>{icon}</Box>
            <Box>
              <Box component="dt" sx={{fontSize: 13, color: 'text.secondary', mb: 0.5, textTransform: 'uppercase'}}>{label}</Box>
              <Box component="dd" sx={{m: 0, fontSize: 16, fontWeight: 600, lineHeight: 1.3}}>{value === null || value === undefined || value === '' ? '—' : value}</Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
